// extracted by mini-css-extract-plugin
export var table_body = "styles-module--table_body--2a67e";
export var table_card_color = "styles-module--table_card_color--158e8";
export var table_card_color_background = "styles-module--table_card_color_background--077a0";
export var table_card_color_info = "styles-module--table_card_color_info--282aa";
export var table_head = "styles-module--table_head--7b26b";
export var table_wrapper = "styles-module--table_wrapper--f1763";